<template>
<div :class="['resource-item', {'grid-aspect': column_superseded}, {'columns is-variable is-2': !column_superseded}, {'is-mobile': !is_mobile}]">
    <div class="resource-item__thumbnail-holder">
        <router-link v-if="!item.is_external" class="is-block" :to="item.link">
            <figure v-if="item.image" class="thumbnail">
                <img :src="item.image.url" :alt="item.title" class="is-block" />
            </figure>
            <span v-if="item.show_type" class="resource-item__type">{{ item.item_type }}</span>
        </router-link>
        <a v-else class="is-block" :href="item.link" target="_blank">
            <figure v-if="item.image">
                <img :src="item.image.url" :alt="item.title" class="is-block" />
            </figure>
            <span v-if="item.show_type" class="resource-item__type">{{ item.item_type }}</span>
        </a>
    </div>
    <div class="resource-item__content">
        <h3 class="resource-item__title title colour-orange">
            <router-link v-if="!item.is_external" class="colour-orange" :to="item.link">{{item.title}}</router-link>
            <a v-else class="colour-orange" :href="item.link" target="_blank">{{item.title}}</a>
        </h3>
        <div class="content" ref="content" v-html="item.content"></div>
        <div :class="['resource-item__cta', {'has-text-right': !column_superseded}]">
            <router-link v-if="!item.is_external" class="button is-purple is-rounded" :to="item.link">{{ item.link_label }}</router-link>
            <a v-else target="_blank" class="button is-purple is-rounded" :href="item.link">{{ item.link_label }}</a>
        </div>
    </div>
</div>
</template>

<script>
import WindowResizeHandler from '@/components/mixins/WindowResizeHandler';
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name        :   'ResourceItem',
    mixins      :   [ WindowResizeHandler, ViewBlockItemMixin ],
    props       :   ['item'],
    data()
    {
        return {
            is_mobile   :   false,
            is_pad      :   false,
            col_size    :   4
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods :   {
        handle_window_resize(width)
        {
            this.is_mobile  =   width < 768;
            if (width >= 768 && width < 960) {
                this.col_size   =   6;
                this.is_pad     =   true;
            } else {
                this.col_size   =   4;
                this.is_pad     =   false;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/ResourceItem.vue